import {Component} from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import '../../css/styles.css';
import LessonList from './lesson_list';
import LessonLinkList from './datasets/lesson_link_list';

class DisplayLessonListModal extends Component {
        constructor(props) {
            super(props);
            this.state={
                linkListArr: LessonLinkList,
        }
        this.reformatLinkList();
    }

    reformatLinkList(){
        const totalDocs = this.state.linkListArr.length;
        const remainder = this.state.linkListArr.length % 2;
        let lineCount = 0;
        const sortedLinkList = this.state.linkListArr.sort((a, b) => 
            (a.order > b.order) ? 1 : -1);
        this.lessonListArr = [];
        while (lineCount <= totalDocs){                       
            const indx1 = lineCount;
            const indx2 = lineCount + 1;
            let newLineObj = {};
            if (remainder === 0 || lineCount < (totalDocs - 1)){
                newLineObj = {lesson1Name: sortedLinkList[indx1].lesson, lesson1Title: sortedLinkList[indx1].lessonTitle, 
                    linkArr1: sortedLinkList[indx1].linkArr, lesson2Name: sortedLinkList[indx2].lesson, 
                    lesson2Title: sortedLinkList[indx2].lessonTitle, linkArr2: sortedLinkList[indx2].linkArr};
            }else{
                newLineObj = {lesson1Name: sortedLinkList[indx1].lesson, 
                    lesson1Title: sortedLinkList[indx1].lessonTitle, linkArr1: sortedLinkList[indx1].linkArr,
                    lesson2Name: "", lesson2Title: "", linkArr2: []}
            }
            this.lessonListArr.push(newLineObj);
            lineCount += 2;
        }
    }
        
    render() {
        this.linkListDisplay= this.lessonListArr.map((linkItem,key) =>
            <LessonList key={key} outInfo={linkItem} />
                );  
    return <>
        <Modal show={this.props.show}  onHide={() => this.props.onClose()} size="lg" scrollable="true"
            animation={false}>
            <Modal.Header className="gameChoiceModalHdrFtrBackground" closeButton>
                <Modal.Title>Instructional Materials</Modal.Title> 
            </Modal.Header>
            <Modal.Body >
                <div>Below are links to key documents for each of the 12 lessons in the 
                    "Money Train: Guide to Financial Literacy" course.
                </div>
                <ul className="mt-2 bulleted-list">
                    <li>
                    Lesson Plans offer a quick overview.
                    </li>
                    <li>
                    Facilitator Guides provide detailed instructions.
                    </li>
                    <li>
                    Student Worksheets are included for every lesson.
                    </li>
                </ul>
                <div>
                    All documents are in PDF format. Click a link to open the file; 
                    you can then download or print it as needed.
                </div>                   
                <div className = "row">
                    {this.linkListDisplay}
                </div>
            </Modal.Body>
            <Modal.Footer className="gameChoiceModalHdrFtrBackground">
            <img src="./assets/sidebar_icon.png" className="train_icon_thumbnail_img mr-5"
                    alt="trainIcon"/>
                <Button  variant="info"   onClick={() => this.props.onClose()}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
       
        </>
    }



}

export default DisplayLessonListModal;